import React from 'react';

import { ExternalLink } from '../Link/Link';
import { Typography, TypographyProps } from '../Typography/Typography';

type ExternalLinkOrDefaultProps = {
  url: string | null;
  label: string;

  /** @default 'N/A' */
  defaultValue?: TypographyProps['children'];
};

export const ExternalLinkOrDefault = (props: ExternalLinkOrDefaultProps) => {
  const { url, label, defaultValue } = props;
  return url ? <ExternalLink href={url}>{label}</ExternalLink> : <Typography>{defaultValue || 'N/A'}</Typography>;
};
